<template>
  <div class="refresh-cdn-container">
    <el-card class="text-solid">
      <el-tooltip class="score-tips" effect="dark" placement="right">
        <div slot="content">
          <h6>预热需知：括号外为腾讯云剩余次数，括号内为华为云剩余次数。</h6>
          <p><span style="color:red">*</span>1. CDN预热是每日限次1000次，预热Cdn能提高资源加载速度。</p>
          <p><span style="color:red">*</span>2. 可预热以下资源类型：</p>
          <p>（1）Common： https://front-xxx-cdn.xsyx.xyz/，xxx为 xps | asset | daily | qa | grey | prod。</p>
          <p>（2）Uat： https://uat-xxx-cdn.xsyx.xyz/，xxx为 xps。</p>
          <p>（3）Combo： https://xxx-cdn.xsyx.xyz/，xxx为 uat-combo-xps | combo-xps。</p>
          <p><span style="color:red">*</span>3. 如需要更多CDN预热的资源类型或对CDN预热存在疑问，请联系系统管理员。</p>
        </div>
        <i class="el-icon-info" type="text"></i>
      </el-tooltip>
      <i class="grade" :title="`腾讯云还剩下 ${cdnQuota.Available} 次CDN预热次数，华为云还剩下${quotas.quota_limit - quotas.used }次CDN预热次数。`">{{cdnQuota.Available}}（{{quotas.quota_limit - quotas.used }}）</i>
      <span v-show="showWarn" class="score-desc">CDN预热次数不足20%，已发送预警信息！</span>
    </el-card>
    <el-card>
      <el-button circle size="mini" type="success" @click="addUrlSource" icon="el-icon-plus" title="新增"></el-button>
      <el-form :model="cdnSourceForm" ref="cdnSourceForm" label-width="100px" class="demo-dynamic">
        <el-form-item v-for="(item, index) in cdnSourceForm.sources" :label="'资源' + index" :key="item.key" :prop="'sources.' + index + '.cdnPath'" :rules="cdnSourceFormRules">
          <el-input v-model="item.cdnPath" :style="{width:'85%'}"></el-input>
          <el-button :style="{padding:'0 5px',color:'red'}" type="text" icon="el-icon-delete" @click.prevent="removeSource(item)"></el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <span class="refresh-cdn-footer">
      <el-button :loading="loading" type="primary" @click="submitForm('cdnSourceForm')">提交</el-button>
      <el-button @click="resetForm('cdnSourceForm')">重置</el-button>
    </span>
  </div>

</template>

<script>
import { xpsApi } from '@/api';
const defaultCdnSourceForm = {
  sources: [{
    cdnPath: '',
    key: Date.now()
  }],
}
let validateCdnPath = (rule, value, callback) => {
  if (/^https\:\/\/front|uat\-xps|uat\-combo\-xps|combo\-xps|asset|daily|qa|grey|prod\-cdn\.xsyx\.xyz\//.test(value)) {
    callback()
  } else {
    callback(new Error('不支持该地址格式'))
  }
}

export default {
  props: {
    quotas: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      cdnSourceForm: JSON.parse(JSON.stringify(defaultCdnSourceForm)),
      cdnSourceFormRules: [
        {
          required: true, message: '资源地址不能为空', trigger: 'blur'
        },
        { validator: validateCdnPath, trigger: 'blur' }
      ],
      cdnQuota: {
        Available: 1000,
        Total: 1000
      },
      loading: false,
      isShowDesc: true
    };
  },
  computed: {
    showWarn () {
      return this.isShowDesc && (this.cdnQuota.Available / this.cdnQuota.Total < 0.2) || this.quotas.used / this.quotas.quota_limit >= 0.8
    }
  },
  mounted () {
    this.getPreheatCDNQuota();
    setTimeout(() => {
      this.isShowDesc = false;
    }, 12000)
  },
  methods: {
    // 获取CDN刷新配额
    async getPreheatCDNQuota () {
      const res = await xpsApi.getPreheatCDNQuota();
      if (res.code === 200) {
        this.cdnQuota = res.data.UrlPush[0];
      }
    },
    // 关闭对话框
    handleClose () {
      this.resetForm('cdnSourceForm');
      this.$emit('close');
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let fileList = []
          this.cdnSourceForm.sources.map((item) => {
            fileList.push(item.cdnPath.trim())
          })
          const res = await xpsApi.preheatCDN({ fileList })
          if (res.code === 200) {
            this.$emit('close');
            this.resetForm(formName)
            this.$message.success(res.message)
          } else {
            this.$emit('close');
            this.$message.error(res.message)
          }
          this.loading = false;
        } else {
          return false;
        }
      });
    },
    // 重置表单
    resetForm (formName) {
      this.cdnSourceForm = JSON.parse(JSON.stringify(defaultCdnSourceForm))
      this.$refs[formName].resetFields();
    },
    // 移除资源
    removeSource (item) {
      if (this.cdnSourceForm.sources.length > 1) {
        var index = this.cdnSourceForm.sources.indexOf(item)
        if (index !== -1) {
          this.cdnSourceForm.sources.splice(index, 1)
        }
      } else {
        this.$message.warning('已经是最后一个资源了！无法删除哦~');
      }
    },
    // 新增资源
    addUrlSource () {
      if (this.cdnSourceForm.sources.length < 20) {
        this.cdnSourceForm.sources.push({
          value: '',
          key: Date.now()
        });
      } else {
        this.$message.warning('一次最多只能预热20条资源数据！')
      }

    }
  }
}
</script>

